var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scY > 300),expression:"scY > 300"}],staticClass:"bt--top right-0 bottom-0",attrs:{"id":"pagetop"},on:{"click":_vm.toTop}},[_c('i',{staticClass:"fas fa-arrow-circle-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }